<template>
  <div class="demoAccountManagement-container">
    <div class="title">
      <div>{{ $t('manage.name111') }}</div>
      <el-button type="primary" @click="addListData(1)">{{ $t('operate.name11') }}</el-button>
      <el-button type="primary" style="margin-left: 15px" @click="saveListData(1)" :loading="loading1">{{ $t('screen.name168') }}</el-button>
    </div>
    <div class="list">
      <div class="item-list" v-for="(item, index) in listData1" :key="index">
        <div class="item-content">
          <div class="item-label">{{ $t('manage.name112') }}</div>
          <el-input v-model="item.accountName" :placeholder="$t('public.name5')"></el-input>
        </div>
        <div class="item-content">
          <div class="item-label">{{ $t('manage.name113') }}</div>
          <el-input v-model="item.websiteUrl" :placeholder="$t('public.name5')"></el-input>
        </div>
        <div class="item-content">
          <div class="item-label">{{ $t('login.name20') }}</div>
          <el-input v-model="item.loginName" :placeholder="$t('public.name5')"></el-input>
        </div>
        <div class="item-content">
          <div class="item-label">{{ $t('login.name21') }}</div>
          <el-input v-model="item.loginPwd" :placeholder="$t('public.name5')"></el-input>
        </div>
        <div @click="delAccount(item,index,1)"><i class="el-icon-circle-close"></i></div>
      </div>
    </div>
    <div class="title marin-top40">
      <div>{{ $t('manage.name111') }}</div>
      <el-button type="primary" @click="addListData(2)">{{ $t('operate.name11') }}</el-button>
      <el-button type="primary" style="margin-left: 15px" @click="saveListData(2)" :loading="loading2">{{ $t('screen.name168') }}</el-button>
    </div>
    <div class="list">
      <div class="item-list" v-for="(item, index) in listData2" :key="index">
          <el-upload
            class="avatar-uploader"
            action
            :http-request="
              (e) => {
                handleUpLoadFile(index, e)
              }
            "
            :show-file-list="false"
          >
            <img v-if="item.imgPath1" :src="item.imgPath1" class="avatar2" />
            <i v-else class="el-icon-plus"></i>
          </el-upload>
        <div class="item-content">
          <div class="item-label">{{ $t('manage.name114') }}</div>
          <el-input v-model="item.accountName" :placeholder="$t('public.name5')"></el-input>
        </div>
        <div class="item-content">
          <div class="item-label">{{ $t('login.name20') }}</div>
          <el-input v-model="item.loginName" :placeholder="$t('public.name5')"></el-input>
        </div>
        <div class="item-content">
          <div class="item-label">{{ $t('login.name21') }}</div>
          <el-input v-model="item.loginPwd" :placeholder="$t('public.name5')"></el-input>
        </div>
        <div @click="delAccount(item,index,2)"><i class="el-icon-circle-close"></i></div>
      </div>
    </div>
  </div>
</template>
<script>
import { demoAccountSave, demoAccountQueryList, demoAccountDalete } from '@/api/user.js'
// import { downloadExcel } from '@/utils/utils'
import { uploadFile } from '@/api/manage.js'
export default {
  data() {
    return {
      loading1: false,
      loading2: false,
      listData1: [],
      listData2: []
    }
  },
  created() {},
  mounted() {
    this.getDemoAccountQueryList()
  },
  methods: {
    getDemoAccountQueryList() {
      demoAccountQueryList().then(res => {
        if (res.code === 200) {
          this.listData1 = res.data.list1
          this.listData2 = res.data.list2
          this.listData2.map((item) => {
            item.imgPath1 = item.imgPath
          })
          if (this.listData1.length === 0) {
            this.addListData(1)
          }
          if (this.listData2.length === 0) {
            this.addListData(2)
          }
        }
      }).catch(res => {
      })
    },
    addListData(type) {
      if (type === 1) {
        const obj = {
          accountName: '',
          websiteUrl: '',
          loginName: '',
          loginPwd: '',
          type: type,
          imgPath: '',
          imgPath1: '',
          id: ''
        }
        this.listData1.push(obj)
      } else {
        const obj = {
          accountName: '',
          websiteUrl: '',
          loginName: '',
          loginPwd: '',
          type: type,
          imgPath: '',
          imgPath1: '',
          id: ''
        }
        this.listData2.push(obj)
      }
    },
    handleUpLoadFile(index, param) {
      const formData = new FormData()
      formData.append('multipart', param.file)
      const loading = this.$loading({
        lock: true,
        text: this.$t('public.name35'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      uploadFile(formData)
        .then(res => {
          loading.close()
          console.log('====', index)
          if (res.code === 200) {
            this.listData2[index].imgPath1 = res.data.fileUrl
            this.listData2[index].imgPath = res.data.objectName
            // console.log('=====', this.listData2)
            this.$message.success(this.$t('public.name42'))
          }
        })
        .catch(res => {
          loading.close()
        })
    },
    saveListData(type) {
      var postData = []
      if (type === 1) {
        this.loading1 = true
        postData = this.listData1
      } else {
        this.loading2 = true
        postData = this.listData2
      }
      demoAccountSave(postData).then(res => {
        if (res.code === 200) {
          this.getDemoAccountQueryList()
        }
        this.loading1 = false
        this.loading2 = false
      }).catch(res => {
        this.loading1 = false
        this.loading2 = false
      })
    },
    delAccount(item, index, type) {
      if (item.id) {
        this.$confirm(this.$t('screen.name14'), this.$t('public.name23'), {
          confirmButtonText: this.$t('public.name25'),
          cancelButtonText: this.$t('public.name14'),
          type: 'warning'
        })
          .then(() => {
            const formData = {
              id: item.id
            }
            demoAccountDalete(formData)
              .then((res) => {
                if (res.code === 200) {
                  this.$message({
                    type: 'success',
                    message: this.$t('public.name30')
                  })
                  this.getDemoAccountQueryList()
                }
              })
              .catch((res) => {})
          })
          .catch(() => {})
      } else {
        if (type === 1) {
          this.listData1.splice(index, 1)
        } else {
          this.listData2.splice(index, 1)
        }
      }
    }
  }
}
</script>
<style lang="scss">
.avatar-uploader {
  margin-right: 30px;
  margin-left: 20px;
  .el-upload {
    width: 100px;
    height: 100px;
  }
  .el-icon-plus {
    font-size: 30px;
  }
}
</style>
<style lang="scss" scoped>
.demoAccountManagement-container {
  display: flex;
  flex-direction: column;
  .marin-top40 {
    margin-top: 40px;
  }
  .title {
    display: flex;
    flex-direction: row;
    align-items: center;
    div {
      font-size: 18px;
      margin-right: 15px;
    }
  }
  .list {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    .item-list {
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-top: 15px;
      .avatar-uploader {
        width: 100px;
        height: 100px;
        .el-upload {
          width: 100px;
          height: 100px;
        }
        .el-icon-plus {
          font-size: 30px;
        }
        .avatar2{
          width: 100px;
          height: 100px;
        }
      }
      .item-content {
        display: flex;
        flex-direction: row;
        align-items: center;
        .item-label {
          width: 120px;
          margin-left: 20px;
          text-align: right;
        }
      }
      .el-icon-circle-close {
        font-size: 26px;
        font-weight: 800;
        margin-left: 20px;
      }
    }
  }
}
</style>
